export default "__VITE_ASSET__C20v7P8g__"